//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import back from '@/assets/back.png'
import celie from '@/assets/celie.png'
import didi from '@/assets/didi.png'
import screen from '@/assets/screen.png'
import serach from '@/assets/serch.png'
import workMsgIcon from '@/assets/work_msg.png'
import {
  BASIC
} from "@/config/constant"
import promise from '@/axios/promise'
import {
  formatTime,
  guid,
  isNullOrEmptyStr,
  isNullOrEmptyArr
} from "@/utils/common"
var page = 1;
var limit = 10;
var DonePage = 1;
var DoneLimit = 10;
export default {
  name: 'workbench',
  data() {
    return {
      loading: false,
      refreshing: false,
      loading1: false,
      showAdd: false,
      refreshing1: false,
      shift: 'movies',
      active3: this.$store.state.user.wkIndex,
      active1: 0,
      undoTasks: [],
      doneTasks: [],
      roleMenus: [],
      undoCount: 0,
      doneCount: 0,

      searchInfo: {
        procName: '',
        status: '',
        taskTopic: ''
      },
    }
  },
  computed: {
    portrait() {
      return this.$store.state.user.portrait
    },
    name() {
      return this.$store.state.user.user
    },
    wKindex() {
      this.active3 = this.$store.state.user.wkIndex;
      return this.$store.state.user.wkIndex
    },
    username() {
      return this.$store.state.user.username
    }
  },
  methods: {
    refresh() {
      page = 1;
      this.loading = true;
      setTimeout(() => {
        var pageLimit = {
          'page': page,
          'limit': limit
        }
        promise({
          url: BASIC + "/task/getTaskList",
          method: "get",
          params: {
            'page': page,
            'limit': limit,
            taskType: 'undo',
            taskTopic: this.searchInfo.taskTopic
          }
        }).then(res => {
          this.undoTasks = res.data;
          this.undoCount = res.count;
          this.loading = false;
        })
      }, 500)
    },
    doneRefresh() {
      DonePage = 1;
      this.loading1 = true;
      setTimeout(() => {
        var pageLimit = {
          'page': page,
          'limit': limit
        }
        promise({
          url: BASIC + "/task/getTaskList",
          method: "get",
          params: {
            'page': DonePage,
            'limit': DoneLimit,
            taskType: 'done',
            taskTopic: this.searchInfo.taskTopic
          }
        }).then(res => {
          debugger;
          this.doneTasks = res.data;
          this.doneCount = res.count;
          this.loading1 = false;
        });
      }, 500)
    },
    load() {
      page++;
      this.loading = true;
      setTimeout(() => {
        var pageLimit = {
          'page': page,
          'limit': limit
        }
        promise({
          url: BASIC + "/task/getTaskList",
          method: "get",
          params: {
            'page': page,
            'limit': limit,
            taskType: 'undo',
            taskTopic: this.searchInfo.taskTopic
          }
        }).then(res => {
          this.loading = false;
          this.undoCount = res.count;
          if (res.data.length != '0') {
            for (var i = 0; i < res.data.length; i++) {
              this.undoTasks.push(res.data[i])
            }
          }
        })
      }, 500)
    },
    Doneload() {
      DonePage++;
      this.loading1 = true;
      setTimeout(() => {
        var pageLimit = {
          'page': page,
          'limit': limit
        }
        promise({
          url: BASIC + "/task/getTaskList",
          method: "get",
          params: {
            'page': DonePage,
            'limit': DoneLimit,
            taskType: 'done',
            taskTopic: this.searchInfo.taskTopic
          }
        }).then(res => {
          this.loading1 = false;
          this.doneCount = res.count;
          if (res.data.length != '0') {
            for (var i = 0; i < res.data.length; i++) {
              this.doneTasks.push(res.data[i])
            }
          }
        });
      }, 500)
    },
    changeWkIndex: function (val) {
      this.active3 = val;
      this.$store.dispatch('changeWkIndex', this.active3);
      if (val == 1) {
        this.getUndoTask();
        this.getDoneTask();
      }
    },
    taskSearch: function () {
      if (this.active1 == 0) {
        this.getUndoTask();
      } else {
        this.getDoneTask();
      }
    },
    /*获取待办任务数据*/
    getUndoTask: function () {
      promise({
        url: BASIC + "/task/getTaskList",
        method: "get",
        params: {
          limit: 10,
          taskType: 'undo',
          taskTopic: this.searchInfo.taskTopic
        }
      }).then(res => {
        this.undoTasks = res.data;
        this.undoCount = res.count;
      });
    },
    /*获取已办任务数据*/
    getDoneTask: function () {
      promise({
        url: BASIC + "/task/getTaskList",
        method: "get",
        params: {
          limit: 10,
          taskType: 'done',
          taskTopic: this.searchInfo.taskTopic
        }
      }).then(res => {
        this.doneTasks = res.data;
        this.doneCount = res.count;
      });
    },
    logout: function () {
      var _this = this;
      // this.$confirm('确认退出吗?', '提示', {
      // }).then(() => {
      _this.$store.dispatch('FedLogOut')
        .then(() => {
          _this.$router.push('/login');
            var system ={
            win : false,
            mac : false,
            xll : false
            };
            //检测平台
            var p = navigator.platform;
            system.win = p.indexOf("Win") == 0;
            system.mac = p.indexOf("Mac") == 0;
            system.x11 = (p == "X11") || (p.indexOf("Linux") == 0);
            if(system.win||system.mac||system.xll){

            }else{
              //微信需要注释以下两行
               plus.navigator.setStatusBarBackground('#000000');
 					     plus.navigator.setFullscreen(true);
            }

        });

      // }).catch(() => {
      // });
    },
    taskClick: function (task, type) {
      var taskId = task.taskId;
      var taskTopic = task.taskTopic;
      var showConfirm = task.showConfirm;
      var businessKey = task.businessKey;
      var taskUrl = task.taskUrl;
      var taskDefinitionKey = task.taskDefinitionKey;
      this.$router.push({
        path: taskUrl,
        query: {
          taskTopic: taskTopic,
          taskId: taskId,
          taskType: type,
          showConfirm: showConfirm,
          businessKey: businessKey,
          taskDefinitionKey: taskDefinitionKey
        }
      });
    },
    getRoleMenus: function () {
      promise({
        url: BASIC + '/user/app/menus',
        method: 'get',
        params: {
          menuType: 'APP'
        }
      }).then(response => {
        this.showAdd = true;
        this.roleMenus = response;
      });
    },
    goPath: function (path) {
      this.$router.push({
        path: path
      });
    },
    editMenu: function () {
      this.$router.push({
        path: "/editMenu"
      });
    },
    modifyPwd: function () {
      this.$router.push({
        path: "/pwd/modify"
      });
    },
    preview: function () {
      this.$router.push({
        path: "/test/preview"
      });
    }
  },
  filters: {
    formatDate(time) {
      if (time == null) {
        return "";
      }
      var date = new Date(time);
      return formatTime(date, 'yyyy-MM-dd');
    },
    formatDateTime(time) {
      if (time == null) {
        return "";
      }
      var date = new Date(time);
      return formatTime(date, 'yyyy-MM-dd hh:mm:ss');
    }
  },
  created() {
    this.getUndoTask();
    this.getDoneTask();
    this.getRoleMenus();
  }

}



// WEBPACK FOOTER //
// ./src/view/index/workbench.vue